// extracted by mini-css-extract-plugin
module.exports = {"button":"Avatar_button__2chwY","full-width-avatar":"Avatar_full-width-avatar__2HhAE","avatar":"Avatar_avatar__2JFsX"};